import React from "react";
import * as Icons from "lucide-react";
import { SERVICES } from "../mock";

const Services = () => {
  return (
    <section id="services" className="py-24 bg-[#EFE6D6]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[#BF9A5A] text-sm font-700">المزايا والخدمات</span>
          <h2 className="font-display text-3xl lg:text-5xl font-700 text-[#241C15] mt-3 leading-snug">
            تفاصيل تعزز الراحة وجودة الحياة
          </h2>
          <p className="text-stone-600 mt-5 leading-relaxed">
            مجموعة متكاملة من الخدمات والمرافق لتجربة سكن وتشغيل متكاملة قرب الحرم المكي.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Dot;
            return (
              <div
                key={i}
                className="group bg-white rounded-2xl p-5 border border-stone-200/60 hover:bg-[#241C15] hover:-translate-y-1 transition-all duration-300 shadow-sm"
              >
                <div className="w-12 h-12 rounded-xl bg-[#F3ECE0] group-hover:bg-[#BF9A5A] flex items-center justify-center transition-colors">
                  <Icon className="text-[#BF9A5A] group-hover:text-white transition-colors" size={22} />
                </div>
                <div className="mt-4 font-700 text-[#241C15] group-hover:text-white text-sm transition-colors">
                  {s.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
